import type { Page } from '~/utils/solr/literature'

/**
 *  Sorts pages by proximity to the current page, with non-numeric page numbers sorted last
 */
export function sortByProximity(docs: Page[], currentPageId: string | undefined): Page[] {
  const currentPage = Number.parseInt(currentPageId ?? '')
  if (Number.isNaN(currentPage)) {
    return docs
  }

  return [...docs].sort((a, b) => {
    const pageA = Number.parseInt(a.pageNumberString ?? '')
    const pageB = Number.parseInt(b.pageNumberString ?? '')

    // Non-numeric page numbers are sorted last
    if (Number.isNaN(pageA) && Number.isNaN(pageB)) {
      return 0
    }
    if (Number.isNaN(pageA)) {
      return 1
    }
    if (Number.isNaN(pageB)) {
      return -1
    }

    const distanceA = Math.abs(pageA - currentPage)
    const distanceB = Math.abs(pageB - currentPage)
    if (distanceA !== distanceB) {
      return distanceA - distanceB
    }

    // Prefer the earlier page if distances are equal (pages before current position win over pages after)
    return pageA - pageB
  })
}
